(function () {
  'use strict';

  /* @ngdoc object
   * @name sprechstunde
   * @description
   */
  angular
    .module('sprechstunde', [
      'ngAria',
      'ui.router',
      'ui.bootstrap',
      'ngCookies',
      'ngTagsInput',
      'ui.bootstrap.typeahead',
      'restmod',
      'ngLodash',
      'cfp.hotkeys',
      'home',
      'vcutils',
      'vcclient',
      'vcconsult',
      'vcexam',
      'vcexamtemplate',
      'vcdms',
      'vcdms.vcfile',
      'vcdrug',
      'vctodo',
      'vcchat',
      'vcfinance',
      'vcreminder',
      'vcuser',
      'vcuser.vclogin',
      'vcpatdocs',
      'vctracker'//,
      // 'vcdevice'
    ]);

  angular.module('sprechstunde')
    .filter('moment', function () {
      return function (dateString, format) {
        return moment(dateString).locale('de-at').format(format);
      };
    })
    .filter('addweeks', function () {
      return function (weeks, format) {
        return moment().add(weeks * 7, 'days').locale('de-at').format(format);
      };
    })
    .filter('javadate', function () {
      return function (javadate, format) {
        return moment(javadate, 'YYYYMMDD-HHmmss').locale('de-at').format(format);
      };
    })
    .filter('trustUrl', ['$sce', function ($sce) {
      return function (recordingUrl) {
        return $sce.trustAsResourceUrl('/routes/files/filereader/' + recordingUrl);
      };
    }])
    .config([
      '$compileProvider',
      function ($compileProvider) {
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|data|blob):/);
      }
    ])
    .config(['$compileProvider', function ($compileProvider) {
      $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|local|data):/);
    }])
    // this interceptor will ad a custom header containing the tabid to every request
    .factory('tabidInterceptor', ['$log', '$window', function ($log, $window) {
      return {
        request: function (config) {
          var uuid;

          // helper function to create uuid
          function guid() {
            function s4() {
              return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
            }

            return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
              s4() + '-' + s4() + s4() + s4();
          }

          if ($window.sessionStorage.getItem('sprtabid')) {
            uuid = $window.sessionStorage.getItem('sprtabid');
          } else {
            uuid = guid();
            $log.debug('Tab UUID created: ', uuid);
            $window.sessionStorage.setItem('sprtabid', uuid);
          }
          config.headers['X-tabid'] = uuid;
          return config;
        }
      };
    }])
    .config(function ($httpProvider) {
      $httpProvider.interceptors.push('tabidInterceptor');
    })
    // restmod cookie handling?
    .run(['$cookies', '$rootScope', '$log', function ($cookies, $rootScope, $log) {
      $rootScope.username = $cookies.get('username');
      $log.debug('cookies initialised: ', $cookies.get('username'));
    }])
    .config(['restmodProvider', '$httpProvider', function (restmodProvider, $httpProvider) {
      restmodProvider.rebase({
        $config: {
          style: 'SprechstundeStyle!'
        },
        $hooks: {
          'before-request': function () {
            $httpProvider.defaults.withCredentials = true;
          }
        }
      });
    }])

    // login: HTTP 401 interceptor
    .factory('AuthInterceptor', ['$injector', '$location', '$q', '$log', function ($injector, $location, $q, $log) {
      return {
        responseError: function (rejection) {
          var $state;
          console.log('rejection: ', rejection);
          if (rejection.status === 401 && rejection.config.url !== '/login') {
            $state = $injector.get('$state');
            // This is the interesting bit: (redirect to initially entered url)
            $log.debug('app-module location url: ', $location.url());
            if ($location.url() !== '/login') {
              $state.go('login', {url: $location.url()});
            }

          }
          return $q.reject(rejection);
        }
      };
    }])
    .config(['$httpProvider', function ($httpProvider) {
      $httpProvider.interceptors.push('AuthInterceptor');
    }])
    .config(['vertxEventBusProvider', function (vertxEventBusProvider) {
      vertxEventBusProvider
        .enable()
        .useDebug(true)
        .useSockJsReconnectInterval(5000)
        .useReconnect(true);
    }])
    .config(['vertxEventBusServiceProvider', function (vertxEventBusServiceProvider) {
      vertxEventBusServiceProvider
        .useDebug(true);
    }])
    // make sure that hotkeys ngroute support does not interfere with ui.router
    .config(['hotkeysProvider', function (hotkeysProvider) {
      hotkeysProvider.useNgRoute = false;
    }])
    .run(['hotkeys', '$state', '$log', function (hotkeys, $state, $log) {
      $log.debug('app hotkeys entered');
      var OSName = "Unknown OS";
      if (navigator.appVersion.indexOf("Win") != -1) OSName = "Windows";
      if (navigator.appVersion.indexOf("Mac") != -1) OSName = "MacOS";
      if (navigator.appVersion.indexOf("X11") != -1) OSName = "UNIX";
      if (navigator.appVersion.indexOf("Linux") != -1) OSName = "Linux";
      console.log("%%%%% OS:  ", OSName);
      hotkeys
        .add({
          combo: 'alt+n',
          description: 'Neuer Patient',
          callback: function () {
            $state.go('newpatient');
          }
        });
      hotkeys
        .add({
          combo: 'alt+f',
          description: 'Patient Finden',
          callback: function () {
            $state.go('patientsearch');
          }
        })
      ;
    }])
    // get previous state tagged onto new state
    .run(['$rootScope', '$state', function ($rootScope, $state) {
      $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        $state.previousState = fromState;
        $state.previousParams = fromParams;
      });
    }])
    .directive('ngReallyClick', [function () {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          element.bind('click', function () {
            var message = attrs.ngReallyMessage;
            if (message && confirm(message)) {
              scope.$apply(attrs.ngReallyClick);
            }
          });
        }
      };
    }])
    .directive('autofocus', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          element[0].focus();
        }
      };
    })
    .directive('showfocus', function ($timeout) {
      return function (scope, element, attrs) {
        scope.$watch(attrs.showFocus,
          function (newValue) {
            $timeout(function () {
              newValue && element[0].focus();
            });
          }, true);
      };
    })
    .directive('mobilerefresh', ['$window', '$rootScope', '$log', function ($window, $rootScope, $log) {
      $window.onfocus = function () {
        console.log('%%%% Window received focus');

        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
          || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {


          $log.debug('This is a mobile browser!');

          // setting up heartbeat if not initalised yet
          if (angular.isUndefined($rootScope.connfailure)) {
            $rootScope.connfailure = 0;
          }
          if (angular.isUndefined($rootScope.heartbeat)) {
            $rootScope.heartbeat = moment();
          }
          // check if there was a heartbeat recorded within the last then 10s
          // Opening and closing file selection for file upload triggered page refresh, and killing file upload
          if (!$rootScope.heartbeat.isBetween(moment().subtract(10000, 'ms'), moment())) {
            // $log.debug('connection exists');
            $window.location.reload();
          }
        }
      };
      // $document.onvisibilitychange = function () {console.log('%%%% document changed visibility: ', $document);};
    }])
  ;


}());
